var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#A4AAC4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.093 15.245l-4.539-4.656c-.32-.325-.32-.853.001-1.179l4.538-4.655c.321-.325.32-.853-.002-1.178-.322-.325-.843-.325-1.165.001L7.39 8.232c-.963.975-.963 2.561 0 3.535l4.537 4.655c.161.163.372.245.584.245.21 0 .42-.082.581-.244.322-.325.323-.853.002-1.178z",
    transform: "translate(-303.000000, -898.000000) translate(303.000000, 888.000000) translate(10.000000, 20.000000) scale(-1, 1) translate(-10.000000, -20.000000) translate(0.000000, 10.000000) translate(-0.000000, 0.000000) translate(10.000000, 10.000000) rotate(90.000000) translate(-10.000000, -10.000000)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.b349795792e22426363d0d9c52f9548d.svg";
export { ForwardRef as ReactComponent };